<div class="variant-skus">
  <ng-container *ngIf="false">
    <fieldset>
      <legend [translate]="'TITLES.PRODUCT_VARIANTS'">
        Product Variants
        <a
          href="javascript:;"
          class="ml-2"
          (click)="editVariants()"
          *ngIf="authService.loginUser.role != 2"
        >
          <i class="fas fa-edit"></i>
        </a>
        <!-- <a class="btn btn-primary edit-variants right" href="javascript:;" (click)="editVariants()"
                [translate]="'BUTTONS.UPDATE_VARIANTS'">
                <i class="fas fa-edit"></i> Edit Variants
            </a> -->
      </legend>

      <div class="form-group variants" *ngFor="let variant of rfq.product_variants">
        <div *ngIf="variant.variant_terms">
          <span class="name">{{ variant.variant_name }}</span>
          <span class="terms">{{ variant.variant_terms }}</span>
          <!-- <span class="terms">{{ variant.variant_terms.join(", ") }}</span> -->
        </div>
      </div>
    </fieldset>
    <hr />
  </ng-container>

  <div class="d-flex justify-content-end">
    <button
      type="button"
      class="lum-button lum-button--secondary"
      (click)="addVariantSku()"
    >
      <i class="fas fa-plus"></i>
      Add Variant SKU
    </button>
  </div>

  <table class="table table-striped">
    <thead>
      <tr>
        <th>Product Variant</th>
        <th>Product Name</th>
        <th>Incoming</th>
        <th>On Hand</th>
        <th>Pending</th>
        <th>Available</th>
        <th width="70px">&nbsp;</th>
      </tr>
      <tr *ngIf="rfq.gettingVariantSKUs">
        <td colspan="8" class="text-center"
          ><i class="fas fa-spinner fa-spin"></i> Getting Product Variant...</td
        >
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let r of rfq.variant_skus; let i = index">
        <tr *ngIf="r.status > -1">
          <td>
            <a
              [routerLink]="['/inventory', r.id, 'view']"
              [queryParams]="{ flag: true }"
              routerLinkActive="router-link-active"
            >
              {{ r.internal_sku }}
            </a>
          </td>
          <td>
            {{ r.product_name }}
          </td>
          <td>
            <span
              *ngIf="r.stock && r.stock.qty_incoming && r.stock.qty_incoming > 0"
            >
              {{
                r.stock.qty_incoming && r.stock.qty_incoming > 0
                  ? r.stock.qty_incoming
                  : (0 | number: '1.0-0')
              }}
            </span>
            <span
              *ngIf="!r.stock || !r.stock.qty_incoming || r.stock.qty_incoming <= 0"
            >
              0
            </span>
          </td>
          <td>
            {{
              (r.stock && r.stock.qty_onhand > 0 ? r.stock.qty_onhand : 0)
                | number: '1.0-0'
            }}
          </td>
          <td>
            {{
              (r.stock && r.stock.qty_pending > 0 ? r.stock.qty_pending : 0)
                | number: '1.0-0'
            }}
          </td>
          <td>
            <span *ngIf="!r.stock"> 0 </span>
            <span
              *ngIf="r.stock"
              [ngClass]="{
                'text-danger font-500':
                  r.qty_limit_notify > 0 &&
                  r.stock.qty_onhand - r.stock.qty_pending <= r.qty_limit_notify,
              }"
            >
              {{ r.stock.qty_onhand - r.stock.qty_pending | number: '1.0-0' }}
            </span>
          </td>

          <td class="actions text-right">
            <div>
              <a
                href="javascript:;"
                class="link-edit"
                (click)="editVariantSku(r, i)"
                title="{{ 'TEXT.EDIT_RECORD' | translate }}"
              >
                <mat-icon
                  class="mat-icon"
                  color="primary"
                  role="img"
                  aria-hidden="true"
                  >edit
                </mat-icon>
              </a>
              <a
                href="javascript:;"
                class="link-warn"
                (click)="delete(r)"
                title="{{ 'TEXT.DELETE_RECORD' | translate }}"
              >
                <mat-icon
                  class="mat-icon"
                  color="warn"
                  role="img"
                  aria-hidden="true"
                  >delete
                </mat-icon>
              </a>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
